// Show cents so the configurator's displayed price matches the exact price
// Shopify charges in the cart (e.g. $25,070.72, not a rounded $25,071).
const usdFormatter = new Intl.NumberFormat("en-US", {
  currency: "USD",
  maximumFractionDigits: 2,
  minimumFractionDigits: 2,
  style: "currency",
});

export const formatCurrency = (value: number): string => usdFormatter.format(value);
